import React, { useState } from 'react'
import { Icon, Label, Message } from 'semantic-ui-react'
import { KNOCKOUTS, PROJECT, SCREENER, SEARCHED_FOR } from './project'

// Context for a reviewer who opens this page cold. The question they are
// really being asked is "could a sourcer judge project fit from these search
// results", and that is unanswerable without knowing what the project wants —
// so the brief sits beside the results rather than in another tab.
//
// Collapsed by default: it is reference material, and the table of people is
// what people came for.
const ProjectBrief = () => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Message info className="sourcing-project">
                These external experts were recommended for the{' '}
                <strong>{PROJECT.team}</strong> project{' '}
                <strong>{PROJECT.title}</strong>
                <div className="auth-user-id">{PROJECT.id}</div>
                <button
                    type="button"
                    className="sourcing-toggle"
                    onClick={() => setOpen(!open)}
                >
                    <Icon name={open ? 'caret down' : 'caret right'} />
                    {open ? 'Hide' : 'Show'} what this project is looking for
                </button>
            </Message>

            {open && (
                <div className="sourcing-brief">
                    <section>
                        <h4>What the project needs</h4>
                        <p>{PROJECT.description}</p>
                        <p className="auth-user-muted">
                            Target: {PROJECT.targetN} completed interviews
                        </p>
                        <div className="sourcing-keywords">
                            {PROJECT.keywords.map((word) => (
                                <Label key={word} size="tiny" basic>
                                    {word}
                                </Label>
                            ))}
                        </div>
                    </section>

                    <section>
                        <h4>Who we searched for</h4>
                        <p className="auth-user-muted">
                            Stage 1 recommended{' '}
                            {SEARCHED_FOR.recommendedCount.toLocaleString()}{' '}
                            people out of the national provider registry. These
                            are the registry specialties they hold — read off
                            the pool itself, since the search brief is generated
                            per run and not stored.
                        </p>
                        <ul className="sourcing-criteria">
                            {SEARCHED_FOR.specialties.map(({ name, share }) => (
                                <li key={name}>
                                    {name}
                                    <span className="auth-user-muted">
                                        {' '}
                                        · {share}
                                    </span>
                                </li>
                            ))}
                        </ul>
                        <p className="auth-user-muted">
                            Credentials: {SEARCHED_FOR.credentials.join(', ')} ·
                            Country: {SEARCHED_FOR.country}
                        </p>
                    </section>

                    <section>
                        <h4>Must answer yes to all of these</h4>
                        <p className="auth-user-muted">
                            Screener knockouts — the sharpest statement of who
                            the project will accept.
                        </p>
                        <ul className="sourcing-knockouts">
                            {KNOCKOUTS.map((question) => (
                                <li key={question}>{question}</li>
                            ))}
                        </ul>
                    </section>

                    <section>
                        <h4>Screener questions</h4>
                        {SCREENER.map(({ question, choices }) => (
                            <div className="sourcing-question" key={question}>
                                <div className="sourcing-question-text">
                                    {question}
                                </div>
                                <div className="sourcing-choices">
                                    {choices.map((choice) => (
                                        <span
                                            key={choice}
                                            className="sourcing-choice"
                                        >
                                            {choice}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </section>
                </div>
            )}
        </>
    )
}

export default ProjectBrief
